//External
import React, { Fragment, useEffect, useState } from "react";
import { useRouter } from "next/router"; //Access routing
//Internal
import { Link } from "./../../routes"; //Access routing
import AddressGetInTouch from "../addressgetintouch";
// const AddressGetInTouch = dynamic(() => import("../addressgetintouch"));
import {
  strToLowerCase,
  replaceSpaceWithHypenToLowercase,
  get_cookie,
  set_cookie,
  hrefURL,
  getFadeFlag,
} from "../../utils";

import FooterNav from "../footer-nav";
import FooterCopyright from "../footer-copyright";
import IconInstagram from "../icons/icons-instagram";
import IconFacebook from "../icons/icons-facebook";
import IconYoutube from "../icons/icons-youtube";
import IconLinkedin from "../icons/icons-linkedin";
// import CookieNotification from "components/modals/cookieNotification";

/*******************
  @Purpose : used for footer
  @Parameter : {addressInfo,brandList,categoryList,currentLocationId,cmsList,currentPage,dynamicPageList,isShowAddressInfo,locations,selectedLocationName}
  @Author : INIC
  *******************/
function Footer({
  addressInfo,
  brandList,
  categoryList,
  currentLocationId,
  cmsList,
  currentPage,
  dynamicPageList,
  isShowAddressInfo,
  locations,
  selectedLocationName,
}) {

  const router = useRouter();
  const { slug } = router.query;
  const is_mobile_app = get_cookie("is_mobile_app");

  const [isActive, setActiveId] = useState("");
  const [isIosChrome, setIsIosChrome] = useState();
  const [redirectUrl, setRedirectUrl] = useState(false);


  useEffect(() => {
    const url = get_cookie("redirectUrl");
    if (url && url != "/") {
      setRedirectUrl(true);
    } else {
      setRedirectUrl(false);
    }
  }, [get_cookie("redirectUrl")]);

  /*******************
@purpose : Check device is iphone and set
@Parameter : {}
@Author : INIC
******************/
  useEffect(() => {
    setIsIosChrome(getFadeFlag());
  }, [isIosChrome]);

  /*******************
  @Purpose : used for set active id
  @Parameter : {id}
  @Author : INIC
  *******************/
  const toggleActive = (id) => {
    if (isActive == id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  let slug1 = "ca";
  let slug2 = "los-angeles";

  if (slug) {
    slug1 = strToLowerCase(slug[0]);
    if (slug[1]) {
      slug2 = strToLowerCase(slug[1]);
    }
  }

  /*******************
  @Purpose : used for capitalize
  @Parameter : {slug}
  @Author : INIC
  *******************/
  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  /*******************
  @Purpose : used for common navigations
  @Parameter : {slug}
  @Author : INIC
  *******************/
  const commonNavigation = (slug) => {
    toggleActive("");
    router.push(slug);
  };

  /*******************
  @Purpose : used for common navigations for dynamic page
  @Parameter : {slug}
  @Author : INIC
  *******************/
  const getDynamicPageUrl = (slug, flag, redirect) => {
    let finalUrl = "";
    if (flag == "CMS") {
      finalUrl = "/" + slug;
    } else if (flag == "Serving") {
      let base = "ca";
      let redirectUrl = get_cookie("redirectUrl");
      if (redirect && redirectUrl != "/") {
        base = "fl";
      }
      finalUrl = "/" + base + "/" + slug;
    } else {
      // propose url
      let base = "/ca/los-angeles";
      let redirectUrl = get_cookie("redirectUrl");
      if (redirect && redirectUrl != "/") {
        base = redirectUrl;
      }
      finalUrl = base + "/" + slug;
    }
    return finalUrl;
  };

  const navigationsForDynamicPage = (slug, flag) => {
    const finalUrl = getDynamicPageUrl(slug, flag, redirectUrl);
    router.push(finalUrl);
  };

  const getClassNameFromCurrentPage = (checkPage) => {
    if (checkPage == "blogdetail") {
      return "site-footer mt-auto blog-detail-footer";
    } else if (
      checkPage == "cms" ||
      checkPage == "faqs" ||
      checkPage == "blog" ||
      checkPage == "about" ||
      checkPage == "about-us" ||
      checkPage == "contact-us"
    ) {
      return "site-footer mt-auto pb-0";
    } else {
      return `site-footer mt-auto ${isIosChrome ? "chrome-footer" : ""}`;
    }
  };

  /*******************
   @Purpose : set redirect url in cookie
   @Parameter : {data}
   @Author : INIC
  *******************/
  const setRedirectURLInCookie = (data) => {
    let path = "";
    if (
      strToLowerCase(data.state_short_name) == "ca" &&
      data.city_slug == "los-angeles"
    ) {
      path = "/";
    } else {
      path =
        "/" +
        strToLowerCase(data.state_short_name) +
        "/" +
        replaceSpaceWithHypenToLowercase(data.city_slug);
    }
    set_cookie("redirectUrl", path, 1);
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <Fragment>
      {isShowAddressInfo ? (
        <AddressGetInTouch
          addressInfo={addressInfo}
          currentLocationId={currentLocationId}
          selectedLocationName={selectedLocationName}
          currentPage={currentPage}
        />
      ) : (
        ""
      )}
      <footer className={getClassNameFromCurrentPage(currentPage)}>
        <div className="footer-wrapper">
          <div className="custom-container">
            <div className="row">
              <div className="col-sm-6 col-lg-3">
                <div
                  className={
                    isActive == 1
                      ? "h-100 footer-item active"
                      : "footer-item h-100"
                  }
                >
                  <h3 className="font-18" onClick={() => toggleActive(1)}>
                    Company
                  </h3>
                  <ul className="list-unstyled footer-menu">
                    {cmsList &&
                      cmsList?.map((cmsAbout, index) => {
                        return (
                          cmsAbout.slug === "about" && (
                            <li key={index}>
                              <Link href={"/" + cmsAbout.slug}>
                                <a
                                  className="menu-link"
                                  title={cmsAbout.title}
                                  onClick={() => toggleActive("")}
                                >
                                  {cmsAbout.title}
                                </a>
                              </Link>
                            </li>
                          )
                        );
                      })}

                    <li key="2">
                      <Link href="/vehiclebooking">
                        <a className="menu-link" title="Reserve Now">
                          Reserve Now
                        </a>
                      </Link>
                    </li>
                    <li key="3">
                      <Link href="/blog">
                        <a className="menu-link" title="Blog">
                          Blog
                        </a>
                      </Link>
                    </li>
                    <li key="4">
                      <Link href="/faqs">
                        <a className="menu-link" title="FAQs">
                          FAQs
                        </a>
                      </Link>
                    </li>
                    <li key="5">
                      <Link href="/contact-us">
                        <a className="menu-link" title="Contact Us">
                          Contact Us
                        </a>
                      </Link>
                    </li>
                    {/* insert cmslist here */}
                    {cmsList &&
                      cmsList?.map(
                        (cms, index) =>
                          cms.slug !== "about" &&
                          cms.slug !== "privacy-policy" &&
                          cms.slug !== "terms-and-conditions" && (
                            <li key={index}>
                              <Link href={"/" + cms.slug}>
                                <a
                                  className="menu-link"
                                  title={cms.title}
                                  onClick={() => toggleActive("")}
                                >
                                  {cms.title}
                                </a>
                              </Link>
                            </li>
                          )
                      )}

                    {/* insert cms and proposed url here */}
                    {dynamicPageList &&
                      dynamicPageList.map((data, index) => {
                        return (
                          (data.page_type !== "Serving" ||
                            (data.page_type === "Serving" &&
                              data.slug === "luxury-car-rental")) && (
                            <li className="dropdown-items" key={index}>
                              <Link
                                href={getDynamicPageUrl(
                                  data?.slug,
                                  data?.page_type, redirectUrl
                                )}
                              >
                                <a
                                  className="menu-link"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    toggleActive("");
                                    navigationsForDynamicPage(
                                      data?.slug,
                                      data?.page_type
                                    );
                                  }}
                                  title={data?.page_title || data?.pagename}
                                >
                                  {data?.page_title || data?.pagename}
                                </a>
                              </Link>
                            </li>
                          )
                        );
                      })}
                  </ul>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3">
                <div
                  className={
                    isActive == 2
                      ? "h-100 footer-item active"
                      : "footer-item footer-two-column"
                  }
                >
                  <h3 className="font-18" onClick={() => toggleActive(2)}>
                    Makes
                  </h3>
                  <ul className="list-unstyled footer-menu count-2">
                    {brandList &&
                      brandList.map((data, index) => (
                        <li className="dropdown-items" key={index}>
                          <Link href={hrefURL(data.slug)}>
                            <a
                              className="menu-link"
                              title={data.title}
                              onClick={() => toggleActive("")}
                            >
                              {data.title}
                            </a>
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3">
                <div
                  className={
                    isActive == 3
                      ? "h-100 footer-item active"
                      : "footer-item h-100"
                  }
                >
                  <h3 className="font-18" onClick={() => toggleActive(3)}>
                    Categories
                  </h3>
                  <ul className="list-unstyled footer-menu">
                    {categoryList &&
                      categoryList.map((data, index) => (
                        <li className="dropdown-items" key={index}>
                          <Link href={hrefURL(data.slug)}>
                            <a
                              className="menu-link"
                              title={data.title}
                              onClick={() => toggleActive("")}
                            >
                              {data.title}
                            </a>
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3">
                <div
                  className={
                    isActive == 4
                      ? "h-100 footer-item active"
                      : "footer-item footer-two-column"
                  }
                >
                  <h3 className="font-18" onClick={() => toggleActive(4)}>
                    Serving
                  </h3>
                  <ul className="list-unstyled footer-menu count-2">
                    {dynamicPageList &&
                      dynamicPageList.map((data, index) => {
                        if (
                          data.page_type === "Serving" &&
                          data.slug !== "luxury-car-rental"
                        ) {
                          return (
                            <li className="dropdown-items" key={index}>
                              <Link
                                href={getDynamicPageUrl(
                                  data.slug,
                                  data.page_type, redirectUrl
                                )}
                              >
                                <a
                                  className="menu-link"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    toggleActive("");
                                    navigationsForDynamicPage(
                                      data?.slug,
                                      data?.page_type
                                    );
                                  }}
                                  title={data?.page_title || data?.pagename}
                                >
                                  {data?.page_title || data?.pagename}
                                </a>
                              </Link>
                            </li>
                          );
                        }
                        return null;
                      })}

                    {locations &&
                      locations?.map((data, index) => (
                        <li key={index}>
                          {data.id !== currentLocationId ? (
                            <Link
                              href={
                                strToLowerCase(data.state_short_name) == "ca" &&
                                  data.city_slug == "los-angeles"
                                  ? "/"
                                  : "/" +
                                  strToLowerCase(data.state_short_name) +
                                  "/" +
                                  replaceSpaceWithHypenToLowercase(
                                    data.city_slug
                                  )
                              }
                            >
                              <a
                                className="menu-link"
                                title={data.city_name}
                                onClick={() => setRedirectURLInCookie(data)}
                              >
                                {data.city_name}
                              </a>
                            </Link>
                          ) : (
                            ""
                          )}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="custom-container">
            <div className="footer-bottom-row">

              {/* Copyright — bottom on mobile, left on desktop */}
              <div className="order-3 order-md-1 mt-2 mt-md-0">
                <FooterCopyright />
              </div>

              {/* Stripe — middle on both */}
              <div className="order-2 order-md-2 my-md-0 d-flex align-items-center" style={{ marginTop:'20px', marginBottom:'20px' }}>
                <img
                  src="/assets/images/stripe-badge.png"
                  alt="Powered by Stripe"
                  style={{ height: '26px', width: 'auto' }}
                />
              </div>

              {/* Social links — top on mobile, right on desktop */}
              <ul className="list-unstyled d-flex align-items-center mb-0 social-links order-1 order-md-3">
                <li>
                  <Link
                    href={
                      addressInfo && addressInfo["company_instagram_url"]
                        ? addressInfo["company_instagram_url"]
                        : "#"
                    }
                    target="_blank"
                  >
                    <a title="Instagram" rel="noopener" target="_blank">
                      <IconInstagram />
                    </a>
                  </Link>
                </li>
                <li>
                  <Link
                    href={
                      addressInfo && addressInfo["company_facebook_url"]
                        ? addressInfo["company_facebook_url"]
                        : "#"
                    }
                    target="_blank"
                  >
                    <a title="Facebook" rel="noopener" target="_blank">
                      <IconFacebook />
                    </a>
                  </Link>
                </li>
                <li>
                  <Link
                    href={
                      addressInfo && addressInfo["company_youtube_url"]
                        ? addressInfo["company_youtube_url"]
                        : "#"
                    }
                    target="_blank"
                  >
                    <a title="YouTube" rel="noopener" target="_blank">
                      <IconYoutube />
                    </a>
                  </Link>
                </li>
                <li>
                  <Link
                    href={
                      addressInfo && addressInfo["company_linkedin_url"]
                        ? addressInfo["company_linkedin_url"]
                        : "#"
                    }
                    target="_blank"
                  >
                    <a title="LinkedIn" rel="noopener" target="_blank">
                      <IconLinkedin />
                    </a>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/* Mobile footer nav */}
      {is_mobile_app !== "yes" &&
        currentPage != "cms" &&
        currentPage != "blog" &&
        currentPage != "faqs" &&
        currentPage != "about" &&
        currentPage != "blogdetail" &&
        currentPage != "tripDetail" &&
        currentPage != "vehicle" && (
          <FooterNav
            locations={locations}
            selectedLocationName={selectedLocationName}
            currentLocationId={currentLocationId}
            currentPage={currentPage}
          />
        )}

      {/* cookie consent notification start here */}
      {/* <CookieNotification /> */}
      {/* cookie consent notification end here */}
    </Fragment>
  );
}

export default Footer;
